import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/modal-exit/phone_in_talk-positive.svg")